module.exports = __webpack_public_path__ + "img/card3.b9c01140.png";